interface OnlineTestStudentNameProps {
    studentName?: string;
    size?: "text-l" | "text-m";
}

/** Rendered in the header, and below it on mobile where the header row only fits the timer. */
const OnlineTestStudentName = (props: OnlineTestStudentNameProps) => {
    if (!props.studentName) return null;

    return (
        <span
            className={`block ${props.size ?? "text-l"} text-p6-grey-dark truncate`}
            data-testid="online-test-student-name"
        >
            {props.studentName}
        </span>
    );
};

export default OnlineTestStudentName;
